'use strict';
ui.loadTemplateFile('debug.html');

class DebugDialog extends Dialog {
  _element: any;
  _titleBar: any;
  controls: any;
  toggle: any;

  constructor() {
    super('debug.html');

    this.controls = ui.panel(this, '.panel.controls');
    this.controls.hide();

    this.toggle = ui.button(this, '.button.toggle-controls');
    this.toggle.on('clicked', this.toggleControls.bind(this));
  }

  addButton(name: any, callback: any) {
    const button = ui.button();
    button.text(name);
    button._element.addClass('black');
    button.on('clicked', callback);
    this.controls.append(button);
    return button;
  }

  toggleControls() {
    this.controls.toggle();
  }
}

ui.DebugDialog = DebugDialog;
ui.debugDialog = () => {
  return new ui.DebugDialog();
};
